import { Divider, DividerSmall } from "@wix/wix-ui-icons-common";
import defaultComponentData from "./../ricos-schema/legacy/statics/divider.defaults.json.js";
import {
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types/index.js";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common/index.js";
import { DEFAULTS } from "./defaults.js";
import { dividerConverter } from "./divider-converter.js";
import { getAddButtons } from "./getAddButtons.js";
import { getToolbarButtons } from "./getToolbarButtons.js";
import { tiptapExtensions } from "./tiptap/tiptap.js";
import { DIVIDER_TYPE } from "./types.js";
const pluginDivider = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    pmMarkConverters: [],
    pmNodeConverters: [dividerConverter],
    type: DIVIDER_TYPE,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    toolbar: {
      names: [RicosPluginToolbarNames.DIVIDER],
      getButtons: (config2, services) => getToolbarButtons(config2, services)
    },
    getQuickActions: ({ pluginServices }) => [
      {
        id: "divider",
        title: "QuickActionsPlugin_ActionTitle_Divider",
        icon: pluginServices?.context.isMobile ? Divider : DividerSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["separator", "line", "break", "horizontal rule", "section divider"],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          publicCommands.insertBlockWithBlankLines(DIVIDER_TYPE, defaultComponentData);
        }
      }
    ]
  };
};
export {
  pluginDivider
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject.js";
injectCss();
